import React, { useState, useEffect, useMemo } from "react";
import "../../../Assets/Css/EmployeeDashboard.scss";
import { Calendar } from "antd";
import moment from "moment";
import Table from "../../../Components/Table";
import { getDashboardData } from "../../../Services/Dashboard/action";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import {
    getFeatures,
    getModules,
} from "../../../Services/Authentication/action";
import { FaUserCircle } from "react-icons/fa";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import EmployeeDetailsIcon from "../../../Assets/Images/Employee/employee_details.svg";
import TaskDetailIcon from "../../../Assets/Images/Employee/task-detail.svg";
import TaskListIcon from "../../../Assets/Images/Employee/task-list.svg";
import EmpAppreciationIcon from "../../../Assets/Images/Employee/emp-appreciation.svg";
import EmpOnLeaveIcon from "../../../Assets/Images/Employee/emp-onleave.svg";
import WeekTimeLog from "../../../Assets/Images/Employee/timelog.svg";
import { FaList } from "react-icons/fa6";
import { BiCalendarStar } from "react-icons/bi";
import { Bar } from "react-chartjs-2";
import { getSundaysInMonth, getAlternateSaturdaysInMonth } from "../../../Lib/utils";
import NoticeIcon from "../../../Assets/Images/Employee/Notice_icon.svg";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from "chart.js";
import {
    getAttendance,
    addAttendance,
    updateAttendance,
} from "../../../Services/Attendance/action";
import { getIconComponent, getTime } from "../../../Lib/utils";
import { getTasks, updateTask } from "../../../Services/Task/action";
import { getAppreciations } from "../../../Services/Appreciation/action";
import { getLeaves } from "../../../Services/Leave/action";
import useTimerStore from "../../../Lib/timerStore";
import { getUsers, listUsers } from "../../../Services/Users/action";
import { getHolidays } from "../../../Services/Holiday/action";
import { getSpecialday } from "../../../Services/Specialday/action";
import { TbPlaneTilt } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllRemindersList, updateRemindersStatus } from "../../../Services/Reminder/action";
import ModulesList from "../../../Assets/ModulesLiist";
import FeaturesList from "../../../Assets/FeaturesList";
import { AiOutlineEye } from "react-icons/ai";
import UserAvatar from "react-user-avatar";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'
import axios from "axios";
import EventsListsList from "../../../Assets/Images/Attendance/EventsListsList";
import EventsListsCalendar from "../../../Assets/Images/Attendance/EventsListsCalendar";
import { getNotices } from "../../../Services/Notice/action";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const EmployeeDashboard = ({
    dashboardData,
    loading,
    getDatas,
    modules,
    getModulesList,
    getFeaturesList,
    features,
    user,
    getAttendance,
    addAttendance,
    updateAttendance,
    attendance,
    attendanceLoading,
    updateTask,
    getTasks,
    task,
    getAppreciations,
    appreciation,
    leave,
    getLeaves,
    getUsers,
    users,
    getHolidays,
    holiday,
    listUsers,
    updateTaskTimerData,
    getSpecialday,
    specialday,
    notice,
    getNotices,
    getAllRemindersList,
    reminder,
    updateRemindersStatus,
    waterJugs
}) => {
    const [inData, setInData] = useState([]);
    const [leaveData, setLeaveData] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('event');
    const [showCheckboxes, setShowCheckboxes] = useState(true);
    const [eventsData, setEventsData] = useState([]);
    const [totalCasual, setTotalCasual] = useState(0);
    const [totalEarned, setTotalEarned] = useState(0);
    const [totalUnpaid, setTotalUnpaid] = useState(0);
    const [coords, setCoords] = useState();
    const [city, setCity] = useState()
    const header = [{ field: 'Action' }, { field: 'Id' }, { field: 'Task' }, { field: 'Due_Date' }];
    const userProfilePic = localStorage.getItem('userProfilePic');;
    const [year, setYear] = useState(moment().year());
    const [month, setMonth] = useState(moment().month() + 1);
    const location = useLocation();
    const currentUserData = users?.find(u => u.id === user?.id);
    const casualLeave = currentUserData?.casual_leave || user?.casual_leave || 0;
    const [noticeData, setNoticeData] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [reminderData, setReminderData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getAllRemindersList(user?.id)
    }, [getAllRemindersList])

    useEffect(() => {
        const today = moment().startOf("day").format("YYYY-MM-DD");

        const waterJugsFromReminders = reminder?.[0]?.user?.waterJugs || [];

        const waterJugForToday = waterJugsFromReminders.some(
            (item) => moment(item.today_date).startOf("day").format("YYYY-MM-DD") === today
        );

        let combinedReminders = [];
        const userRole = user?.role?.name?.toLowerCase();

        if (!waterJugForToday && userRole !== "employee") {
            combinedReminders.push({
                id: "waterjug-message",
                date: today,
                description: "Please add today's water jug",
                isCustom: true,
            });
        }

        const actualReminders = reminder
            .filter(item => item.status === "pending" || item.autoGenerated)
            .sort((a, b) => {
                if (!a.date) return 1;
                if (!b.date) return -1;
                return new Date(a.date) - new Date(b.date);
            });

        combinedReminders = [...combinedReminders, ...actualReminders];
        setReminderData(combinedReminders);
    }, [reminder]);

    const isPastDate = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const reminderDate = new Date(date);
        reminderDate.setHours(0, 0, 0, 0);

        return reminderDate < today;
    };

    const handleCheckboxChange = (id) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const isAnyChecked = Object.values(checkedItems).some(Boolean);

    const handleComplete = async () => {
        const selectedIds = Object.keys(checkedItems)
            .filter((id) => checkedItems[id] && id !== "waterjug-message")
            .map((id) => parseInt(id, 10));

        if (selectedIds.length === 0) {
            toast.warning("Please select at least one reminder to complete");
            return;
        }

        try {
            await updateRemindersStatus(selectedIds);
            setCheckedItems({});
            await getAllRemindersList(user?.id);
        } catch (error) {
            toast.error("Error updating reminders");
            console.error(error);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    const currentCoords = {
                        lat: latitude,
                        lng: longitude,
                    };
                    setCoords(currentCoords);
                    try {
                        const res = await axios.get(
                            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
                        );
                        const address = res.data?.address;
                        const cityName =
                            address?.city ||
                            address?.state_district ||
                            address?.town ||
                            address?.village ||
                            address?.county ||
                            'Unknown';

                        setCity(cityName);
                    } catch (err) {
                        toast.error('Failed to fetch city');
                        console.error(err);
                    }
                },
                (error) => {
                    toast.error('Please enable your location');
                }
            );
        } else {
            toast.error('Geolocation is not supported by your browser');
        }
    }, []);
    const noticeHeader = [
        { field: "Notice" },
        { field: "Start Date" }
    ];
    const leaveheader = [
        { field: "Code" },
        { field: "Date" },
        { field: "Employee" },
        { field: "Leave Type" },
    ];

    const eventheader = selectedCategory === 'birthday'
        ? [{ field: 'Name' }, { field: 'Date' }]
        : [{ field: 'Event' }, { field: 'Date' }];

    const options = {
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: (ctx) => {
                        const totalSeconds = ctx.raw;
                        const h = Math.floor(totalSeconds / 3600);
                        const m = Math.floor((totalSeconds % 3600) / 60);
                        const s = totalSeconds % 60;
                        return `${ctx.dataset.label}: ${h}h ${m}m ${s}s`;
                    }
                }
            },
            legend: {
                display: true,
                position: 'top',
                align: 'end',
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    boxWidth: 8,
                    boxHeight: 8
                },
            },
            title: {
                display: false,
            },
        },
        grid: {
            display: true,
            color: "rgba(200, 200, 200, 0.2)",
        },
        scales: {
            y: {
                beginAtZero: true,
                min: 0,
                max: 500,
                ticks: {
                    callback: (val) => {
                        const h = Math.floor(val / 3600);
                        const m = Math.floor((val % 3600) / 60);
                        const s = val % 60;

                        if (h > 0) {
                            return `${h}h ${m}m`;
                        } else if (m > 0) {
                            return `${m}m ${s}s`;
                        } else {
                            return `${s}s`;
                        }
                    }
                }

            },
            x: {

            },
        },
    };
    const handleNavigate = (newDate, view, action) => {
        setMonth(moment(newDate).month() + 1);
        setYear(moment(newDate).year());
    }
    useEffect(() => {
        getDatas(user?.id);
        // getModulesList();
        // getFeaturesList();
        getAttendance(user?.id);
        getTasks();
        getAppreciations();
        getLeaves();
        // getUsers();
        listUsers();
        getHolidays();
        getSpecialday();
        getUsers({ module: 'employees' });
        getNotices();
    }, []);

    const isTimerRunning = (task, currentUserId, currentUserRole, allTasks) => {
        const assignedUserIds = task?.taskUserMap?.taskTimerMap?.map(u => u?.employee_id) || [];

        const allRunningTimers = allTasks
            ?.flatMap(task => task?.taskUserMap?.taskTimerMap || [])
            ?.filter(timer => timer?.state !== "stopped");

        if (assignedUserIds.includes(currentUserId) && currentUserRole === "hr_senior") {
            return allRunningTimers.some(t => t?.employee_id === currentUserId);
        }

        return allRunningTimers.some(t => assignedUserIds.includes(t?.employee_id));
    };

    useEffect(() => {
        const updatedTimers = {};
        const validKeys = new Set();

        dashboardData?.allTasks?.forEach((item) => {
            const allTimers = item?.taskUserMap?.taskTimerMap;

            allTimers?.forEach((timer) => {
                const key = `${timer.employee_id}_${timer.task_id}`;
                validKeys.add(key);
                const { time } = getTime(timer.start_time, new Date(), typeof timer.action_history === "string"
                    ? JSON.parse(timer.action_history)
                    : timer.action_history || []);
                updatedTimers[key] = {
                    taskId: timer.task_id,
                    startTime: timer.start_time,
                    status: timer?.state,
                    actionHistory:
                        typeof timer.action_history === "string"
                            ? JSON.parse(timer.action_history)
                            : timer.action_history || [],
                    timer: time
                };
            });
        });

        const filteredExistingTimers = Object.fromEntries(
            Object.entries(useTimerStore.getState().timers).filter(
                ([key]) => validKeys.has(key)
            )
        );

        useTimerStore.setState({
            timers: {
                ...filteredExistingTimers,
                // ...updatedTimers,
            },
        });

        setInData(
            task?.slice(0, 5)?.filter(item => item?.taskUserMap?.some(userMap => userMap?.user_id === user?.id))
                .map((item) => {
                    const allTimers = item?.taskTimerMap;
                    const latestTimer = allTimers?.find(timer => timer?.state != "stopped" && timer?.employee_id == user?.id)

                    return {
                        checkbox: {
                            value: item?.id,
                            value2: item?.taskTimerMap?.find(timer => timer?.state != "stopped")?.id,
                            type: "checkbox",
                        },
                        Id: {
                            value: `CD_${item?.id}`,
                            type: 'text',
                        },
                        Task: {
                            value: item?.title,
                            type: 'text',
                        },
                        Due_Date: {
                            value: item?.due_date ? moment(item.due_date).format('YYYY-MM-DD') : '--',
                            type: 'text',
                        },
                        Action: (() => {
                            return {
                                value: latestTimer?.state || '',
                                type: 'taskstartstop',
                            };
                        })(),
                        timerIsRunning: {
                            value: isTimerRunning(
                                item,
                                user?.id,
                                user?.role?.name,
                                task
                            )
                        },taskId: item?.id, 
                    rawData: item,   
                    clickable: true  
                    };
                })
        );
    }, [task, updateTaskTimerData]);

    useEffect(() => {
        let casual = 0;
        let earned = 0;
        let unpaid = 0;

        leaveData?.filter(item => (item?.user?.id === user?.id) && (item?.status === "Approved"))?.map((item) => {
            if (item?.type === "Casual") casual++;
            if (item?.type === "Earned") earned++;
            if (item?.type === "Unpaid") unpaid++;
        })

        const allLeaves = leave?.filter(item => {
            if (item?.status !== "Approved") return false;
            const itemDateStr = item?.start_date?.split(" ")[0];
            const itemDate = new Date(itemDateStr);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const sevenDaysFromNow = new Date();
            sevenDaysFromNow.setDate(sevenDaysFromNow.getDate() + 8);
            sevenDaysFromNow.setHours(23, 59, 59, 999);
            return itemDate >= today && itemDate <= sevenDaysFromNow;
        })
            ?.sort((a, b) => {
                const dateA = new Date(a?.start_date?.split(" ")[0]);
                const dateB = new Date(b?.start_date?.split(" ")[0]);
                return dateA - dateB;
            })
            ?.map((item) => {
                return {
                    Code: {
                        value: `${item?.user?.employee_code}`,
                        type: 'text',
                    },
                    "Date": {
                        value: item?.start_date?.split(" ")[0],
                        type: 'text',
                    },
                    Employee: {
                        value: item?.user?.name,
                        type: 'text',
                    },
                    "Leave Type": {
                        value: (() => {
                            const casual = parseFloat(item?.casual || 0);
                            const unpaid = parseFloat(item?.unpaid || 0);
                            const types = [];

                            if (casual > 0) types.push("Casual");
                            if (unpaid > 0) types.push("Unpaid");

                            return types.length > 0 ? types.join("/") : (item?.type || "Unknown");
                        })(),
                        value2: item?.duration?.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase()),
                        type: 'leaveType',
                    },
                };
            });
        setLeaveData(allLeaves);
        setTotalCasual(casual);
        setTotalEarned(earned);
        setTotalUnpaid(unpaid);
    }, [leave]);

    useEffect(() => {
        const sundayHolidays = getSundaysInMonth(year, month);
        const saturdayHolidays = getAlternateSaturdaysInMonth(year, month);

        let newData = [];

        const dbHolidays = (holiday || [])
            ?.map(item => ({
                id: item?.id,
                date: moment(item?.date?.split(" ")[0]).format('YYYY-MM-DD'),
                occasion: item?.occasion,
                fromDb: true,
                specialDay: item?.special_day
            }))
            ?.filter(item => {
                const date = moment(item.date, 'YYYY-MM-DD');
                return date.month() + 1 === month && date.year() === year;
            });

        const currentMonthSpecialDays = (specialday || [])
            ?.filter(item => {
                const date = moment(item?.date?.split(" ")[0], 'YYYY-MM-DD');
                return date.month() + 1 === month && date.year() === year;
            })
            ?.map(item => ({
                id: item?.id,
                date: moment(item?.date?.split(" ")[0]).format('YYYY-MM-DD'),
                occasion: item?.occasion,
                fromDb: true,
                specialDay: item?.special_day
            }));

        const birthdayEvents = (users || [])
            ?.filter(user => {
                const birthDate = moment(user.date_of_birth?.split(' ')[0], 'YYYY-MM-DD');
                const noticeEndDate = user.notice_period_end_date
                    ? moment(user.notice_period_end_date, 'YYYY-MM-DD')
                    : null;

                const today = moment();
                return birthDate.isValid() && birthDate.month() + 1 === month && (!noticeEndDate || noticeEndDate.isAfter(today));
            })
            .map(user => ({
                id: user?.id,
                date: moment(user.date_of_birth?.split(' ')[0], 'YYYY-MM-DD').format('YYYY-MM-DD'),
                occasion: user.name,
                name: user.name,
                type: 'birthday'
            }));

        const allHolidays = [...dbHolidays, ...sundayHolidays, ...saturdayHolidays, ...currentMonthSpecialDays]
            .reduce((acc, curr) => {
                if (!acc.find(item => item.date === curr.date)) {
                    acc.push(curr);
                }
                return acc;
            }, [])
            .sort((a, b) => new Date(a.date) - new Date(b.date));

        const combinedEvents = [
            ...allHolidays.map(item => ({
                title: item.occasion,
                start: new Date(item.date),
                end: new Date(item.date),
                allDay: true,
                type: 'holiday',
                id: item.id
            })),
            ...birthdayEvents.map(item => ({
                title: `${item.occasion}'s Birthday`,
                start: new Date(item.date),
                end: new Date(item.date),
                allDay: true,
                type: 'birthday',
                id: item.id
            })),
        ];

        setEventsData(combinedEvents);

        if (selectedCategory === 'event') {
            newData = allHolidays;
        } else if (selectedCategory === 'birthday') {
            newData = users?.filter(user => {
                const noticeEndDate = user.notice_period_end_date
                    ? moment(user.notice_period_end_date, 'YYYY-MM-DD')
                    : null;
                return (
                    !noticeEndDate || noticeEndDate.isAfter(moment())
                );
            });
        } else if (selectedCategory === 'specialday') {
            newData = currentMonthSpecialDays;
        }
        setEventList(
            newData?.filter((item) => {
                if (selectedCategory === 'birthday') return !!item?.date_of_birth;
                return true;
            }).sort((a, b) => {
                if (selectedCategory !== 'birthday') return 0;

                const today = moment();
                const aDate = moment(a.date_of_birth, 'YYYY-MM-DD').year(today.year());
                const bDate = moment(b.date_of_birth, 'YYYY-MM-DD').year(today.year());

                if (aDate.isBefore(today)) aDate.add(1, 'year');
                if (bDate.isBefore(today)) bDate.add(1, 'year');

                return aDate - bDate;
            })
                .slice(0, selectedCategory === 'birthday' ? 6 : newData.length)
                .map((item) => ({
                    Event: {
                        value: item?.occasion,
                        type: 'text',
                    },
                    Name: {
                        value: item?.name,
                        type: 'text',
                    },
                    // 'Name Of Event': {
                    //     value: selectedCategory === 'birthday' ? 'Birthday' : item?.occasion,
                    //     type: 'text',
                    // },
                    Date: {
                        value: selectedCategory === 'birthday'
                            ? moment(item.date_of_birth.split(' ')[0]).format('DD MMMM')
                            : moment(item.date?.split(' ')[0]).format('DD-MM-YYYY'),
                        type: 'text',
                    },
                }))
        );

    }, [users, holiday, specialday, selectedCategory, year, month, location.pathname]);

    const dateCellRender = (value) => {
        const date = value.startOf("day").toDate();
        const tasks = eventsData.filter((entry) => entry.start?.toDateString?.() === date.toDateString());

        if (tasks.length > 0) {
            return (
                <div
                    className="holiday-marker"
                >
                    {tasks.map((task, index) => (
                        <div
                            key={index}
                            className="holiday-occasion"
                            onClick={() => handleNavigate(task)}
                        >
                            {task.title}
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    const eventCheckbox = (category) => {
        setSelectedCategory(category);
    };

    const handleClockOut = async () => {
        try {
            const today_date = new Date();
            const clock_out = today_date.toLocaleTimeString();
            const employee_id = user?.id;

            const body = {
                employee_id,
                clock_out,
                date: today_date
            }

            await updateAttendance(attendance?.id, body);

        } catch (error) {
            console.log("Error in clock Out :", error);
        }
    };

    const handleClockIn = async () => {
        if (!coords) { toast.error("Please enable your location") }
        if (!city) { toast.error("Please enable your location") }
        try {
            const today_date = new Date();
            const clock_in = today_date.toLocaleTimeString();
            const employee_id = user?.id;

            const body = {
                employee_id,
                clock_in,
                date: today_date,
                city: city,
                geocoding: JSON.stringify({
                    latitude: coords.lat,
                    longitude: coords.lng
                })
            }

            await addAttendance(body);
        } catch (error) {
            console.log("Error in clock in :", error);
        }
    };

    const EvenetClick = () => {
        setShowCheckboxes(true);
    };

    const CalendarClick = () => {
        setShowCheckboxes(false);
    };

    const getTodayDay = () => {
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const today = new Date().getDay();
        return days[today];
    };

    const getTodayTime = () => {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    }

    const handleSelect = ({ start, end }) => {
        const title = window.prompt("New Event name");
        if (title)
            setEventsData([
                ...eventsData,
                {
                    start,
                    end,
                    title
                }
            ]);
    };

    const formatTime = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes] = timeString.split(":");
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        return date.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    const attendanceData = () => {

        const todayDate = new Date(attendance?.date)?.toLocaleDateString() === new Date()?.toLocaleDateString();

        return (
            <>
                {(todayDate && attendance?.clock_in && !attendance?.clock_out) ? (
                    <>
                        <div className="time-btn-2 text-md-right">
                            <h4 className="current-time">{getTodayTime()}</h4>
                            <h6 className="day">{getTodayDay()}</h6>
                            <h6 className="clockin-out">Clock in at - {formatTime(attendance?.clock_in)}</h6>
                        </div>
                        <div>
                            {attendanceLoading ? (
                                <button className="clockout-btn btn btn-danger" onClick={handleClockOut}>
                                    <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                                </button>
                            ) : (
                                <button className="clockout-btn btn btn-danger" onClick={handleClockOut}>
                                    <FaArrowRightFromBracket className="clockout-icon" /> Clock Out
                                </button>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        <div className="time-btn-2 text-md-right">
                            <h4 className="current-time">{getTodayTime()}</h4>
                            <h6 className="day">{getTodayDay()}</h6>
                        </div>
                        <div>
                            {attendanceLoading ? (
                                <button className="clockin-btn btn btn-success" onClick={handleClockIn}>
                                    <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                                </button>
                            ) : (
                                <button className="clockin-btn btn btn-success" onClick={handleClockIn}>
                                    <FaArrowRightFromBracket className="clockin-icon" /> Clock In
                                </button>
                            )}
                        </div>
                    </>
                )}
            </>
        )
    }
    useEffect(() => {
        attendanceData();
    }, [attendance])

    const getWeekTimeLogs = () => {
        const weekStart = moment().startOf('week').add(1, 'day');
        const weekEnd = moment().endOf('week').add(1, 'day');

        let totalSeconds = 0;

        task?.filter(item => item?.taskUserMap?.some(userMap => userMap?.user_id === user?.id))?.forEach(task => {
            task.taskTimerMap?.forEach(timer => {
                const start = moment(timer?.start_time);
                const stop = moment(timer?.stop_time);

                const withinWeek =
                    (stop.isValid() && stop.isBetween(weekStart, weekEnd, null, '[]')) ||
                    (start.isValid() && start.isBetween(weekStart, weekEnd, null, '[]'));
                if (withinWeek && timer?.duration) {
                    const parts = timer.duration.match(/(\d+)h\s*(\d+)m\s*(\d+)s/);
                    if (parts) {
                        const [, h, m, s] = parts.map(Number);
                        totalSeconds += h * 3600 + m * 60 + s;
                    }
                }
            });
        });

        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };

    const getWeeklyWorkBreakStats = () => {
        const weekStart = moment().startOf('week').add(1, 'day');
        const weekEnd = moment().endOf('week').add(1, 'day');

        const workDurations = Array(7).fill(0);
        const breakDurations = Array(7).fill(0);

        task
            ?.filter(item => item?.taskUserMap?.some(userMap => userMap?.user_id === user?.id))
            ?.forEach(taskItem => {
                let timers = [];
                try {
                    timers = typeof taskItem?.taskTimerMap === 'string' ? JSON.parse(taskItem.taskTimerMap) : taskItem?.taskTimerMap || [];
                } catch {
                    timers = [];
                }

                timers.forEach(timer => {
                    const start = moment(timer?.start_time);
                    const stop = moment(timer?.stop_time);

                    const withinWeek =
                        (stop.isValid() && stop.isBetween(weekStart, weekEnd, null, '[]')) ||
                        (start.isValid() && start.isBetween(weekStart, weekEnd, null, '[]'));
                    if (!withinWeek) return;

                    const dayIndex = start.isoWeekday() - 1;
                    if (timer?.duration) {
                        const match = timer.duration.match(/(?:(\d+)h)?\s*(?:(\d+)m)?\s*(?:(\d+)s)?/);
                        if (match) {
                            const h = parseInt(match[1] || 0);
                            const m = parseInt(match[2] || 0);
                            const s = parseInt(match[3] || 0);
                            workDurations[dayIndex] += h * 3600 + m * 60 + s;
                        }
                    }

                    let currentPauseStart = null;
                    let actions = [];
                    try {
                        const history = timer?.action_history;

                        actions = typeof history === 'string' ? JSON.parse(history) : (history || []);
                    } catch (error) {
                        console.error("Failed to parse action_history:", error);
                        actions = [];
                    }

                    let parsedActions = [];
                    if (typeof actions === 'string') {
                        try {
                            parsedActions = JSON.parse(actions);
                        } catch (err) {
                            console.error("Failed to parse actions string:", err);
                            parsedActions = [];
                        }
                    } else {
                        parsedActions = Array.isArray(actions) ? actions : [];
                    }

                    parsedActions
                        ?.sort((a, b) => moment(a.time).diff(moment(b.time)))
                        ?.forEach(action => {
                            const actionTime = moment(action.time);
                            if (!actionTime.isValid() || !actionTime.isBetween(weekStart, weekEnd, null, '[]')) return;
                            const dayIdx = actionTime.isoWeekday() - 1;
                            if (action.action === 'pause') {
                                currentPauseStart = actionTime;
                            }
                            if (currentPauseStart && (action.action === 'resume' || action.action === 'stop')) {
                                const duration = moment.duration(actionTime.diff(currentPauseStart)).asSeconds();
                                breakDurations[dayIdx] += duration;
                                currentPauseStart = null;
                            }
                        });
                });
            });

        return {
            workDurations,
            breakDurations,
            rawTotals: {
                work: workDurations.reduce((a, b) => a + b, 0),
                break: breakDurations.reduce((a, b) => a + b, 0),
            }
        };
    };

    const { workDurations, breakDurations } = getWeeklyWorkBreakStats();

    const data = {
        labels: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
        ],
        datasets: [
            {
                label: "Working Duration",
                // data: [6, 6.5, 7, 5.5, 6.2, 5.5,],
                data: workDurations,
                backgroundColor: "#32ADE6",
                borderWidth: 1,
                barThickness: 10,
                maxBarThickness: 10,
                borderRadius: 10,
                justifyContent: "end",
            },
            {
                label: "Break",
                // data: [2, 1.5, 1, 2.5, 1.8, 2.5,],
                data: breakDurations,
                backgroundColor: "#FF3B30",
                borderWidth: 1,
                barThickness: 10,
                maxBarThickness: 10,
                borderRadius: 10,
                justifyContent: "end",
            },
        ],
    };

    useEffect(() => {
        if (notice) {
            const today = moment().startOf('day');

            const processedNotices = notice
                ?.filter((item) => {
                    const startDate = moment(item?.start_date, 'YYYY-MM-DD');
                    const noOfDays = parseInt(item?.no_of_days, 10) || 0;
                    const endDate = moment(startDate).add(noOfDays, 'days');
                    return today.isSameOrAfter(startDate) && today.isBefore(endDate);
                })
                ?.slice(0, 5)
                ?.map((item) => ({
                    "Notice": {
                        value: item?.heading,
                        type: 'text'
                    },
                    "Start Date": {
                        value: moment(item?.start_date?.split(" ")[0]).format('DD-MM-YYYY'),
                        type: 'text'
                    },
                    noticeId: item?.id,
                    rawData: item,
                    clickable: true
                }));

            setNoticeData(processedNotices || []);
        }
    }, [notice]);

    const handleRowClick = (rowData) => {
        navigate(`/task/emptask/view/${rowData.taskId}`);
    };
    return (
        <>
            <div className="employeeDashboard-main">
                <div className="page-titles">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-12 col-md-6">
                            <h4 className="welcome-user">Welcome {user?.name}</h4>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="right-content d-flex">
                                {attendanceData()}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="reminder-division">
                    <div className="reminder-list-part">
                        <h6 className="reminder-list-heading">
                            {loading ? <Skeleton className='rounded-2' width={120} height={30} /> : "Reminder List"}
                        </h6>
                        {isAnyChecked && (
                            <button type="button" className="custom-btn" onClick={handleComplete}>
                                Complete
                            </button>
                        )}
                    </div>

                    <div class="reminder-detail-part">
                        <div class="option-container">
                            {
                                loading ? (
                                    [...Array(5)].map((_, index) => (
                                        <label key={index} className="option-box">
                                            <div style={{ marginBottom: '8px' }}>
                                                <Skeleton className="rounded-2" width={150} height={20} />
                                            </div>
                                            <div style={{ marginBottom: '8px' }}>
                                                <Skeleton className="rounded-2" width={150} height={20} />
                                            </div>
                                        </label>
                                    ))
                                ) : (
                                    reminderData && reminderData.length > 0 ? (
                                        reminderData.map((item) => (
                                            <label
                                                key={item.id}
                                                className={`option-box ${item.isCustom ? "custom" : ""} ${!item.date || isPastDate(item.date) ? "no-date" : ""}`}
                                            >
                                                {!item.isCustom && (
                                                    <>
                                                        <input
                                                            type="checkbox"
                                                            checked={checkedItems[item.id] || false}
                                                            onChange={() => handleCheckboxChange(item.id)}
                                                        />
                                                        <div className="checkmark"></div>
                                                        <div
                                                            className="tooltip-icon"
                                                            onClick={() => navigate(`/reminder/view/${item.id}`)}
                                                        >
                                                            <AiOutlineEye size={13} />
                                                        </div>
                                                    </>
                                                )}
                                                <h4 className="option-date">
                                                    {item.date ? moment(item.date).format("DD-MM-YYYY") : "No Date"}
                                                </h4>
                                                <p className="option-description">{item.description || "No Description"}</p>
                                            </label>
                                        ))
                                    ) : (
                                        <p>No reminders available</p>
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="main-division">
                    <div className="row">
                        <div className="col-lg-6 mb-3">
                            <div className="left-parts d-flex">
                                <div className="employee-sub-row">
                                    {loading ? (
                                        <Skeleton circle width={100} height={100} />
                                    ) : userProfilePic ? (
                                        <img
                                            src={userProfilePic}
                                            className="employee-image"
                                            alt="Employee"
                                        />
                                    ) : (
                                        <UserAvatar
                                            name={user?.name || "U"}
                                            size={100}
                                            style={{ textTransform: 'uppercase', color: 'white' }}
                                            color="#5757fe"
                                        />
                                    )}

                                    <div className="ms-4">
                                        <h6 className="employee-name">
                                            {loading ? <Skeleton width={120} /> : user?.name}
                                        </h6>
                                        <h6 className="employee-info">
                                            {loading ? <Skeleton width={100} /> : user?.designation?.name}
                                        </h6>
                                        <h6 className="employee-info">
                                            {loading ? <Skeleton width={150} /> : `Employee Id : ${user?.employee_code}`}
                                        </h6>
                                        <h6 className="employee-info">
                                            {loading ? (
                                                <Skeleton width={120} />
                                            ) : (
                                                `Leaves : ${casualLeave || 0.00}`
                                            )}
                                        </h6>
                                    </div>
                                </div>
                                {loading ? (
                                    <Skeleton width={50} height={50} />
                                ) : (
                                    <img
                                        src={EmployeeDetailsIcon}
                                        className="employee-icon"
                                        alt="Employee Details"
                                    />
                                )}
                            </div>

                            <div className="left-parts mt-4">
                                <div className="task-list-part">
                                    {
                                        loading ? (
                                            <Skeleton width={200} height={40} />
                                        ) : (
                                            <h6 className="task-list-heading">My Task List</h6>
                                        )
                                    }

                                    {
                                        loading ? (
                                            <Skeleton width={30} height={30} />
                                        ) : (
                                            <img
                                                src={TaskListIcon}
                                                className="employee-icon"
                                                alt="Task list-icon"
                                            />
                                        )
                                    }
                                </div>
                                {
                                    loading ? (
                                        <Skeleton count={5} width="100%" height={40} />
                                    ) : (
                                        <Table
                                            header={header}
                                            data={inData}
                                            updateTask={updateTask}
                                            user={user}
                                            rowClickType="navigate"
                                            onRowClick={handleRowClick}
                                            showPagination={false}
                                             preventNavigationOnAction={true}
                                        />
                                    )
                                }
                            </div>
                            <div className="left-parts mt-4">
                                <div className="task-list-part">
                                    {
                                        loading ? (
                                            <Skeleton height={40} width={200} />
                                        ) : (
                                            <h6 className="task-list-heading">Employee On Leave</h6>
                                        )
                                    }
                                    {
                                        loading ? <Skeleton width={30} />
                                            : <img
                                                src={EmpOnLeaveIcon}
                                                className="employee-icon"
                                                alt="Employee On Leave"
                                            />
                                    }
                                </div >
                                {
                                    loading ? <Skeleton count={4} width="100%" height={20} /> : (
                                        <Table header={leaveheader} data={leaveData} />
                                    )
                                }
                            </div >

                            <div className="left-parts mt-4">
                                <div className="task-list-part">
                                    {
                                        loading ? (
                                            <Skeleton height={40} width={200} />
                                        ) : (
                                            <h6>Events Lists</h6>
                                        )
                                    }
                                    <div className="event-list-icon">
                                        {
                                            loading ? <Skeleton width={30} /> : (
                                                <>
                                                    <button
                                                        onClick={EvenetClick}
                                                        className={`button-event1 ${showCheckboxes ? "active" : ""
                                                            }`}
                                                    >
                                                        <EventsListsList
                                                            color={showCheckboxes ? "white" : "#16085d"}
                                                            bgColor={showCheckboxes ? "#16085d" : "white"}
                                                        />
                                                    </button>
                                                    <button
                                                        onClick={CalendarClick}
                                                        className={`button-event2 ${!showCheckboxes ? "active" : ""
                                                            }`}
                                                    >
                                                        <EventsListsCalendar
                                                            bgColor={showCheckboxes ? "white" : "#16085d"}
                                                            color={showCheckboxes ? "#16085d" : "white"}
                                                        />
                                                    </button>
                                                </>
                                            )
                                        }
                                    </div>
                                </div>

                                {showCheckboxes ? (
                                    <>
                                        <div className="checboxbtn">
                                            {
                                                loading ? <Skeleton width={200} height={40} /> : (
                                                    <>
                                                        <input
                                                            type="radio"
                                                            id="event"
                                                            checked={selectedCategory === "event"}
                                                            onChange={() => eventCheckbox("event")}
                                                        />
                                                        <label htmlFor="event" className="label me-4">Holidays</label>
                                                        <input
                                                            type="radio"
                                                            id="birthday"
                                                            checked={selectedCategory === "birthday"}
                                                            onChange={() => eventCheckbox("birthday")}
                                                        />
                                                        <label htmlFor="birthday" className="label me-4">Birthday</label>

                                                        <input
                                                            type="radio"
                                                            id="specialday"
                                                            checked={selectedCategory === "specialday"}
                                                            onChange={() => eventCheckbox("specialday")}
                                                        />
                                                        <label htmlFor="specialday" className="label">Special Day</label>
                                                    </>
                                                )
                                            }
                                        </div>
                                        {
                                            loading ? <Skeleton count={5} width="100%" height={40} /> : (
                                                <Table header={eventheader} data={eventList} />
                                            )
                                        }
                                    </>
                                ) : (
                                    <div className="holiday-calendar">
                                        < Calendar
                                            mode="month"
                                            dateCellRender={dateCellRender}
                                        />
                                    </div>
                                )}
                            </div>
                        </div >
                        < div className="col-lg-6 mb-3" >
                            <div className="right-parts">
                                <div className="sub-row">
                                    <div className="task-detail-part">
                                        {
                                            loading ? (
                                                <Skeleton height={40} width={200} />
                                            ) : (
                                                <h6 className="task-detail-heading">Task Detail</h6>
                                            )
                                        }
                                        {
                                            loading ? (
                                                <Skeleton width={30} height={30} />
                                            ) : (
                                                <img
                                                    src={TaskDetailIcon}
                                                    className="employee-icon"
                                                    alt="Task Details"
                                                />
                                            )
                                        }
                                    </div>
                                    <div className="row task-info">
                                        <div className="col-md-3 col-sm-6">
                                            {
                                                loading ? (
                                                    <>
                                                        <Skeleton height={100} width="100%" />
                                                    </>
                                                ) : (
                                                    <div className="first-task-info">

                                                        <span className="first-task-no">
                                                            {task?.filter((item) =>
                                                                item?.taskUserMap?.some(
                                                                    (userMap) =>
                                                                        userMap?.user_id === user?.id &&
                                                                        (item?.due_date !== null && new Date(item?.due_date) < new Date())
                                                                )
                                                            ).length || 0}
                                                        </span>
                                                        <span className="first-task-sub-heading">
                                                            Overdue <br /> Task
                                                        </span>

                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className="col-md-3 col-sm-6">
                                            {
                                                loading ? (
                                                    <>
                                                        <Skeleton height={100} width="100%" />
                                                    </>
                                                ) : (
                                                    <div className="second-task-info">
                                                        <span className="second-task-no">
                                                            {task?.filter((item) =>
                                                                item?.taskUserMap?.some(
                                                                    (userMap) =>
                                                                        userMap?.user_id === user?.id &&
                                                                        item?.status?.toLowerCase() === "doing"
                                                                )
                                                            ).length || 0}
                                                        </span>
                                                        <span className="second-task-sub-heading">
                                                            Ongoing <br /> Task
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className="col-md-3 col-sm-6">
                                            {
                                                loading ? (
                                                    <>
                                                        <Skeleton height={100} width="100%" />
                                                    </>
                                                ) : (
                                                    <div className="third-task-info">
                                                        <span className="third-task-no">
                                                            {task?.reduce((acc, item) => {
                                                                const isAssignedToUser = item?.taskUserMap?.some(
                                                                    (map) => map?.user_id === user?.id
                                                                );
                                                                if (!isAssignedToUser) return acc;

                                                                const userStatus = item?.status?.toLowerCase();
                                                                if (userStatus === "incomplete") acc += 1;
                                                                else if (userStatus === "to-do") acc += 1;
                                                                return acc;
                                                            }, 0)}
                                                        </span>
                                                        <span className="third-task-sub-heading">
                                                            Pending <br /> Task
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className="col-md-3 col-sm-6">
                                            {
                                                loading ? (
                                                    <>
                                                        <Skeleton height={100} width="100%" />
                                                    </>
                                                ) : (
                                                    <div className="fourth-task-info">
                                                        <span className="fourth-task-no">
                                                            {task?.filter((item) =>
                                                                item?.taskUserMap?.some(
                                                                    (userMap) =>
                                                                        userMap?.user_id === user?.id &&
                                                                        item?.status?.toLowerCase() === "completed"
                                                                )
                                                            ).length || 0}
                                                        </span>
                                                        <span className="fourth-task-sub-heading">
                                                            Complete <br /> Task
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div >

                            <div className="right-parts mt-4">
                                <div className="sub-row">
                                    <div className="task-detail-part">
                                        <div>
                                            {
                                                loading ? (
                                                    <>
                                                        <Skeleton width={200} height={20} />
                                                        <Skeleton width={200} height={20} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <h6 className="task-detail-heading">Week Timelogs</h6>
                                                        <h6 className="label">{getWeekTimeLogs()} This Week</h6>
                                                    </>
                                                )
                                            }
                                        </div>
                                        {loading ? (
                                            <Skeleton width={40} height={40} />
                                        ) : (
                                            <img
                                                src={WeekTimeLog}
                                                className="employee-icon"
                                                alt="Task Details"
                                            />
                                        )}
                                    </div>
                                    {
                                        loading ? (
                                            <Skeleton height={200} width="100%" />
                                        ) : (
                                            <Bar data={data} options={options} />
                                        )
                                    }
                                </div>
                            </div>

                            <div className="right-parts mt-4">
                                <div className="sub-row">
                                    <div className="task-detail-part">
                                        {
                                            loading ? (
                                                <Skeleton width={200} height={20} />
                                            ) : (
                                                <h6 className="task-detail-heading">
                                                    Employee Appreciation
                                                </h6>
                                            )
                                        }
                                        {
                                            loading ? (
                                                <Skeleton width={40} />
                                            ) : (
                                                <img
                                                    src={EmpAppreciationIcon}
                                                    className="employee-icon"
                                                    alt="Task Details"
                                                />
                                            )
                                        }
                                    </div>
                                    {
                                        loading ? (
                                            <Skeleton count={5} width="100%" height={20} />
                                        ) : (
                                            appreciation.length
                                                ? appreciation?.map((item, index) => {
                                                    const Icon = getIconComponent(item?.award?.icon);
                                                    return (
                                                        <div className="row appreciation-info">
                                                            <div className="appreciation-info-detail">
                                                                <div className="employee-info col-lg-5">
                                                                    {!item?.user?.profile_pic?.data ? (
                                                                        <UserAvatar name={item?.user?.name || "U"} size={40} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                                                    ) : (
                                                                        <img
                                                                            src={`data:image/jpeg;base64,${btoa(
                                                                                new Uint8Array(
                                                                                    item?.user?.profile_pic?.data
                                                                                ).reduce(
                                                                                    (data, byte) =>
                                                                                        data + String.fromCharCode(byte),
                                                                                    ""
                                                                                )
                                                                            )}`}
                                                                            className="award-receiver-img"
                                                                            alt="Employee"
                                                                        />
                                                                    )}
                                                                    <div className="employee-details">
                                                                        <h6 className="appreciation-emp-name">
                                                                            {item?.user?.name}
                                                                        </h6>
                                                                        <h6 className="label">
                                                                            {item?.user?.designation?.name}
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="image-cell col-lg-1"
                                                                    style={{
                                                                        backgroundColor:
                                                                            item?.award?.icon_background_color || "#eee",
                                                                        width: 40,
                                                                        height: 40,
                                                                        borderRadius: "50%",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        color: "#fff",
                                                                        fontSize: 20,
                                                                    }}
                                                                >
                                                                    {Icon && <Icon />}
                                                                </div>
                                                                <div className="award-name-info col-lg-4">
                                                                    <h6
                                                                        className="appreciation-emp-name"
                                                                        style={{ textAlign: "right" }}
                                                                    >
                                                                        {item?.award?.title}
                                                                    </h6>
                                                                    <h6 className="label">
                                                                        {item?.date?.split(" ")[0]}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                                : <div className="text-center">No Records</div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="right-parts mt-4">
                                <div className="sub-row">
                                    <div className="task-detail-part">
                                        {loading ? (
                                            <Skeleton width={200} height={20} />
                                        ) : (
                                            <h6 className="task-detail-heading">Notice</h6>
                                        )}
                                        {loading ? (
                                            <Skeleton width={40} />
                                        ) : (
                                            <img
                                                src={NoticeIcon}
                                                className="employee-icon"
                                                alt="Notice"
                                            />
                                        )}
                                    </div>
                                    {loading ? (
                                        <Skeleton count={3} width="100%" height={40} />
                                    ) : (
                                        <div className="notice-table-container">
                                            <Table
                                                header={noticeHeader}
                                                data={noticeData}
                                                rowClickType="navigate"
                                                onRowClick={(rowData) => {
                                                    navigate('/notice/view', { state: { data: rowData } });
                                                }}
                                                showPagination={false}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export const mapStateToProps = (state) => {
    return {
        dashboardData: state.dashboardReducer.dashboardData,
        loading: state.dashboardReducer.loading,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
        attendance: state.attendanceReducer.attendance,
        attendanceLoading: state.attendanceReducer.loading,
        task: state.taskReducer.task,
        appreciation: state.appreciationReducer.appreciation,
        leave: state.leaveReducer.leave,
        users: state.userReducer.users,
        holiday: state.holidayReducer.holiday,
        updateTaskTimerData: state.taskReducer.updateTask,
        specialday: state.specialdayReducer.holiday,
        loading: state.reminderReducer?.loading || state.waterJugReducer.loading || false,
        reminder: state.reminderReducer?.reminder || [],
        waterJugs: state.waterJugReducer.waterjug,
        notice: state.noticeReducer.notice
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getDatas: (id) => {
            dispatch(getDashboardData(id));
        },
        getModulesList: () => {
            dispatch(getModules());
        },
        getFeaturesList: () => {
            dispatch(getFeatures());
        },
        getAttendance: (id) => {
            dispatch(getAttendance(id));
        },
        getTasks: () => {
            dispatch(getTasks());
        },
        getAppreciations: () => {
            dispatch(getAppreciations());
        },
        getLeaves: () => {
            dispatch(getLeaves());
        },
        getUsers: () => {
            dispatch(getUsers());
        },
        listUsers: () => {
            dispatch(listUsers());
        },
        getHolidays: () => {
            dispatch(getHolidays());
        },
        getSpecialday: () => {
            dispatch(getSpecialday());
        },
        addAttendance: (data) => {
            dispatch(addAttendance(data));
        },
        updateAttendance: (id, data) => {
            dispatch(updateAttendance(id, data));
        },
        updateTask: (id, data, showToast) => {
            dispatch(updateTask(id, data, showToast));
        },
        getAllRemindersList: (id) => {
            dispatch(getAllRemindersList(id))
        },
        updateRemindersStatus: (ids) => {
            return dispatch(updateRemindersStatus(ids))
        },
        getNotices: () => {
            dispatch(getNotices());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDashboard);
